<div class="contribution tknSale">
    <div class="row pt-5 d-flex justify-content-start">
        <div class="col-md-12 col-sm-12">
            <nb-list class="detailsList">
                <nb-list-item>
                    <h4>Total Supply</h4>
                    <h4>{{contributionRules.totalSupply | number}} BYND</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Token For Presale</h4>
                    <h4></h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Token For Liquidty</h4>
                    <h4></h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Presale rate</h4>
                    <h4>$0.0{{contributionRules.seedPrice}}</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Listing Rate</h4>
                    <h4>$0.0{{contributionRules.listingPrice}}</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Initial Market Cap (estimate)</h4>
                    <h4>${{contributionRules.assumedInitialMarketCap | number}}</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Soft Cap</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Hard Cap</h4>
                    <h4>${{contributionRules.hardCap | number}}</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Unsold Tokens Refund</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Presale Start Time</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Presale End Time</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Listing on</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Liquidty Percent</h4>
                    <h4>3.09%</h4>
                </nb-list-item>
                <nb-list-item>
                    <h4>Liquidty Lockup Time</h4>
                    <h4>90 days</h4>
                </nb-list-item>
            </nb-list>
        </div>
    </div>
</div>
